import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const PresetTemaPortal = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e6f4f7',
      100: '#c2e5ec',
      200: '#8fcbd9',
      300: '#5aaec2',
      400: '#2a8aa1',
      500: '#0d7a92',
      600: '#0a6175',
      700: '#084e5d',
      800: '#063d49',
      900: '#052f38',
      950: '#031e24',
    },
    formField: {
      borderRadius: '12px',
      sm: {
        fontSize: '0.75rem',
      },
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.600}',
          inverseColor: '#ffffff',
          hoverColor: '{primary.500}',
          activeColor: '{primary.700}',
        },
        surface: {
          0: '#ffffff',
          50: '#f9faf7',
          100: '#f3f4f2',
          200: '#eeecec',
          300: '#e7e8e6',
          400: '#e1e3e1',
          500: '#d9dad8',
          600: '#707976',
          700: '#404946',
          800: '#2e3130',
          900: '#191c1b',
          950: '#0f1110',
        },
        formField: {
          background: '{surface.0}',
          borderColor: '{surface.600}',
          hoverBorderColor: '#00576b',
          focusBorderColor: '{primary.600}',
          color: '{surface.900}',
          placeholderColor: '{surface.600}',
          floatLabelColor: '{primary.600}',
          floatLabelActiveColor: '{primary.600}',
          floatLabelFocusColor: '{primary.600}',
          floatLabelInvalidColor: '#ba1a1a',
        },
        text: {
          color: '{surface.900}',
          mutedColor: '{surface.700}',
          hoverMutedColor: '{surface.800}',
        },
      },
    },
  },
  components: {
    button: {
      root: {
        borderRadius: '12px',
      },
      colorScheme: {
        light: {
          text: {
            secondary: {
              color: '{surface.700}',
            },
          },
        },
      },
    },
    floatlabel: {
      root: {
        color: '{primary.600}',
        activeColor: '{primary.600}',
        focusColor: '{primary.600}',
        invalidColor: '#ba1a1a',
        fontWeight: '500',
        active: {
          fontWeight: '500',
        },
      },
      on: {
        active: {
          background: '{surface.0}',
          padding: '0 0.25rem',
        },
      },
    },
    inputtext: {
      root: {
        borderRadius: '12px',
        borderColor: '{surface.600}',
        hoverBorderColor: '#00576b',
        focusBorderColor: '{primary.600}',
        placeholderColor: '{surface.600}',
      },
    },
    textarea: {
      root: {
        borderRadius: '12px',
        borderColor: '{surface.600}',
        hoverBorderColor: '#00576b',
        focusBorderColor: '{primary.600}',
        placeholderColor: '{surface.600}',
      },
    },
    select: {
      root: {
        borderRadius: '12px',
        borderColor: '{surface.600}',
        hoverBorderColor: '#00576b',
        focusBorderColor: '{primary.600}',
        placeholderColor: '{surface.600}',
      },
    },
  },
});
